import * as React from "react"
import { PropsWithChildren } from "react"

import {
  Address,
  AddressItem,
  Company,
  ContactItem,
  Copyright,
  CopyrightContainer,
  Footer,
  LanguageItem,
  LanguageSwitcher,
  Legal,
  LegalLabel,
  LegalItem,
  FooterContainer,
  LegalLink,
  LanguageLabel
} from "./styles"
import BrandComponent from "../brand"
import { useFooterData } from "../../../hooks/use-footer-data"
import { Page } from "../../../hooks/use-navigation-data"
import { useTranslations } from "../../../hooks/use-translations"


export default function FooterComponent(props: PropsWithChildren<{ locale: string }>) {
  const { company, brand, pages, languages, copyright } = useFooterData()
  const messages = useTranslations(props.locale)
  const localizedPages = pages.filter((page: Page) => page.langKey === props.locale)

  return (
    <Footer>
      <FooterContainer>
      <Company>
        <BrandComponent brand={brand}/>
        <Address>
          <AddressItem>{company.title}</AddressItem>
          <AddressItem>{company.address.street}</AddressItem>
          <AddressItem>{company.address.place}</AddressItem>
          <ContactItem href={company.tel.href}>{company.tel.value}</ContactItem>
          <ContactItem href={company.email.href}>{company.email.value}</ContactItem>
        </Address>
      </Company>
      <Legal>
        <LegalLabel>{messages.footer.legal}</LegalLabel>
        {localizedPages.map(page => (
          <LegalItem key={page.title}>
            <LegalLink to={page.slug}>{page.title}</LegalLink>
          </LegalItem>
        ))}
      </Legal>
      </FooterContainer>

      <LanguageSwitcher>
        <LanguageLabel>{messages.footer.language}</LanguageLabel>
        {languages.map(lang => (
          <LanguageItem key={lang.name} to={lang.href}>
            {lang.name}
          </LanguageItem>
        ))}
      </LanguageSwitcher>
      <CopyrightContainer>
        <Copyright>{copyright}</Copyright>
      </CopyrightContainer>
    </Footer>
  )
}

